export default "__VITE_ASSET__DOQy3u7p__"